const LinkResolver = function (doc) {
    return `/${doc.uid}`;
};

export default LinkResolver;
